export default "__VITE_ASSET__DhQqUZrk__"